<div class="fh-form-section" style="gap: 32px" [formGroup]="form">
  <fieldset>
    <!-- SEZIONE 1: Caratteristiche incarico -->
    <legend class="mb-4 mt-2">Caratteristiche incarico</legend>
    <div class="fh-form-grid gap-3 p-3 border rounded bg-light">
      <div class="fh-form-input-field">
        <label class="fw-semibold" for="coachSpecialty">Specializzazione</label>
        <select name="" id="" formControlName="coachSpecialty">
          <option value="">Seleziona specializzazione</option>
          <option value="LIFE_COACHING">Life coaching</option>
          <option value="COACHING_AZIENDALE">Coaching aziendale</option>
          <option value="EXECUTIVE_COACHING">Executive coaching</option>
          <option value="COACHING_DI_LEADERSHIP">Coaching di leadership</option>
          <option value="LEADERSHIP_COACHING">Leadership coaching</option>
          <option value="MINDFULNESS_COACHING">Mindfulness coaching</option>
          <option value="RELATIONSHIP_COACHING">Coaching relazionale</option>
          <option value="SPIRITUAL_COACHING">Coaching spirituale</option>
          <option value="COACHING_FOR_PERSONAL_GROWTH">
            Coaching per la crescita personale
          </option>
          <option value="CORPORATE_WELLNESS_COACHING">
            Coaching per il benessere aziendale
          </option>
          <option value="MENTAL_COACHING_PER_SPORTIVI_E_PERFORMANCE">
            Mental coaching per sportivi
          </option>
        </select>
      </div>
      <div class="fh-form-input-field">
        <label class="fw-semibold" for="isTrial">Sessione di prova</label>
        <input type="checkbox" id="isTrial" formControlName="trial" />
      </div>
      <div class="fh-form-input-field">
        <label class="fw-semibold" for="coachId">ID Coach assegnato</label>
        <input type="text" id="coachId" formControlName="coachId" />
      </div>
    </div>

    <!-- SEZIONE 2: Durata incarico -->
    <legend class="mb-4 mt-4">Durata incarico</legend>
    <div class="fh-form-grid gap-3 p-3 border rounded bg-light">
      <div class="fh-form-input-field">
        <label class="fw-semibold" for="serviceStart">Inizio stimato</label>
        <input type="date" id="serviceStart" formControlName="serviceStart" />
      </div>
      <div class="fh-form-input-field">
        <label class="fw-semibold" for="serviceDuration"
          >La famiglia avrebbe bisogno fino a</label
        >
        <input
          type="date"
          id="serviceDuration"
          formControlName="serviceDuration"
        />
      </div>
    </div>

    <!-- SEZIONE 3: Descrizione impegno (full width) -->
    <legend class="mb-4 mt-4">Descrizione impegno</legend>
    <div class="fh-form-grid gap-3 p-3 border rounded bg-light">
      <div
        class="fh-form-input-field"
        style="grid-column: 1 / -1; grid-template-columns: 1fr"
      >
        <label class="fw-semibold" for="requestDescription">
          Inserisci la descrizione
          <span style="font-size: 13px; color: grey"
            >"Serve un coach per..."</span
          >
        </label>
        <textarea
          rows="6"
          id="requestDescription"
          maxlength="2048"
          formControlName="requestDescription"
        ></textarea>
      </div>
    </div>

    <!-- SEZIONE 4: Lingue richieste -->
    <legend class="mb-4 mt-4">Lingue richieste</legend>
    <div
      formGroupName="requiredLanguage"
      class="fh-form-grid gap-3 p-3 border rounded bg-light"
    >
      <div
        class="fh-form-input-field"
        style="grid-column: 1 / -1; grid-template-columns: 1fr; gap: 10px"
      >
        <div
          class="fh-form-input-field"
          style="grid-template-columns: auto auto; gap: 10px"
        >
          <label for="italian" class="fw-semibold">Italiano</label>
          <input type="checkbox" id="italian" formControlName="italian" />
        </div>

        <div
          class="fh-form-input-field"
          style="grid-template-columns: auto auto; gap: 10px"
        >
          <label for="english" class="fw-semibold">Inglese</label>
          <input type="checkbox" id="english" formControlName="english" />
        </div>
      </div>
    </div>
     <!-- SEZIONE 5: Ore pacchetto -->
     <legend class="mb-2 mt-4">Costo sessione</legend>
     <p class="text-muted small">*Questo campo serve per calcolare il costo del link di pagamento per la singola sessione di coach</p>
     <div class="gap-3 p-3 border rounded bg-light">
       <div class="fh-form-grid">
         <div class="fh-form-input-field" style="grid-template-columns: auto auto; gap: 10px;">
           <label for="packageFlatCost" class="fw-semibold">Consuntivo sessione</label>
           <input readonly type="number" min="0" id="packageFlatCost" formControlName="packageFlatCost">
         </div>
       </div>
     </div>
  </fieldset>
</div>
